(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oldtrend-shoe-size-chart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    let zoomTrigger = null;
    const closeZoom = (dialog) => {
      dialog.close();
      zoomTrigger?.focus();
      zoomTrigger = null;
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-oldtrend-belt-zoom-open]');
      if (trigger) {
        const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!dialog) return;
        zoomTrigger = trigger;
        dialog.showModal();
        return;
      }
      const close = event.target.closest('[data-oldtrend-belt-zoom-close]');
      if (close) closeZoom(close.closest('dialog'));
      if (event.target.matches('dialog.oldtrend-belt-chart-zoom[open]')) {
        const bounds = event.target.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeZoom(event.target);
      }
    });
    document.addEventListener('keydown', (event) => {
      const dialog = document.querySelector('dialog.oldtrend-belt-chart-zoom[open]');
      if (!dialog) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeZoom(dialog);
      } else if (event.key === 'Tab') {
        event.stopImmediatePropagation();
        const focusable = [...dialog.querySelectorAll('button, a[href], [tabindex="0"]')];
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-predictive"] && !Shopify.designMode) return;
  try {
    (() => {
  const fitViewport = () => document.querySelectorAll('.ot-search.search-popdown').forEach(panel => panel.style.setProperty('--ot-search-vh',`${window.visualViewport?.height || window.innerHeight}px`));
  window.visualViewport?.addEventListener('resize',fitViewport);
  window.addEventListener('resize',fitViewport);
  const initialize = () => customElements.whenDefined('predictive-search').then(() => {
    fitViewport();
    document.querySelectorAll('[data-ot-search]').forEach(search => {
      if (search.dataset.otReady) return;
      search.dataset.otReady = 'true';
      const input = search.querySelector('[name="q"]');
      const results = search.querySelector('[data-predictive-search-results]');
      const config = JSON.parse(search.querySelector('[data-ot-search-config]').textContent);
      const original = results.innerHTML;
      const browse = results.querySelector('.ot-browse').outerHTML;
      const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const safeUrl = value => { try { const url = new URL(value, location.origin); return ['https:','http:'].includes(url.protocol) ? esc(url.href) : '#'; } catch { return '#'; } };
      const urlFor = term => `${config.searchUrl}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(term)}`;
      const money = amount => new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', {style:'currency',currency:config.currency || 'USD',currencyDisplay:config.currencyCode ? 'code' : 'symbol'}).format(Number(amount));
      let controller;
      let generation = 0;
      const refreshFocusTrap = () => {
        const panel = search.closest('#search-popdown');
        if (panel?.classList.contains('is-visible')) search.a11y.trapFocus(panel,{elementToFocus:search.contains(document.activeElement) ? document.activeElement : input});
      };
      const clear = () => {
        controller?.abort();
        generation++;
        results.innerHTML = original;
        search.removeAttribute('loading');
        search.removeAttribute('results');
        search.removeAttribute('open');
        input.setAttribute('aria-expanded','false');
        input.removeAttribute('aria-activedescendant');
        input.form.removeAttribute('aria-busy');
        if (search.loader) search.loader.style.display = 'none';
        refreshFocusTrap();
      };
      search.reset = clear;
      search.shouldResetForm = () => true;
      search.getSearchResults = async term => {
        if (!term.trim()) { clear(); return; }
        controller?.abort();
        controller = new AbortController();
        const current = ++generation;
        search.setLiveRegionLoadingState();
        input.form.setAttribute('aria-busy','true');
        if (search.loader) search.loader.style.display = 'block';
        try {
          const params = new URLSearchParams({q:term,'resources[type]':'query,product,collection,page','resources[limit]':'6','resources[limit_scope]':'each','resources[options][unavailable_products]':'last'});
          const response = await fetch(`${config.suggestUrl}.json?${params}`,{signal:controller.signal,headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Search unavailable');
          const data = (await response.json()).resources.results;
          if (current !== generation || input.value.trim() !== term) return;
          let option = 0;
          const optionAttrs = () => `role="option" aria-selected="false" id="${results.id}-option-${++option}"`;
          const queries = (data.queries || []).slice(0,5);
          const queryLinks = queries.length ? queries.map(item => `<li ${optionAttrs()}><a href="${safeUrl(item.url)}" data-ot-search-term="${esc(item.text)}">${esc(item.text)}</a></li>`).join('') : `<li ${optionAttrs()}><a href="${esc(urlFor(term))}">${esc(term)}</a></li>`;
          const extraLinks = (label,items) => items.length ? `<h2 class="ot-search-heading ot-material-heading">${esc(label)}</h2><ul class="ot-search-links">${items.slice(0,3).map(item => `<li ${optionAttrs()}><a href="${safeUrl(item.url)}">${esc(item.title)}</a></li>`).join('')}</ul>` : '';
          const products = (data.products || []).slice(0,4);
          const cards = products.map(product => {
            const rawImage = product.featured_image?.url || product.image;
            let image = '';
            if (rawImage) { const imageUrl = new URL(rawImage,location.origin); imageUrl.searchParams.set('width','600'); image = `<img src="${safeUrl(imageUrl.href)}" alt="${esc(product.title)}" width="600" height="600" loading="eager">`; }
            const compare = Number(product.compare_at_price_max) > Number(product.price) ? `<s>${esc(money(product.compare_at_price_max))}</s>` : '';
            return `<li class="ot-product-card" ${optionAttrs()}><a href="${safeUrl(product.url)}"><div class="ot-product-image">${image}</div><p class="ot-product-title">${esc(product.title)}</p><p class="ot-product-price">${esc(money(product.price))}${compare}${product.available ? '' : `<span class="ot-product-availability">${esc(config.soldOut)}</span>`}</p></a></li>`;
          }).join('');
          const body = products.length ? `<ul class="ot-product-grid" role="group" aria-label="${esc(config.products)}">${cards}</ul>` : `<div class="ot-empty"><p>${esc(config.empty.replace('__TERM__',term))}</p><p>${esc(config.retry)}</p></div>`;
          results.innerHTML = `<div class="ot-panel" role="listbox" aria-label="${esc(config.suggestions)}"><div class="ot-suggestions"><h2 class="ot-search-heading">${esc(config.suggestions)}</h2><ul class="ot-search-links" role="group">${queryLinks}</ul>${extraLinks(config.collections,data.collections || [])}${extraLinks(config.pages,data.pages || [])}</div>${browse}<div class="ot-products"><h2 class="ot-search-heading">${esc(config.products)}</h2>${body}<button type="submit" class="ot-search-all" ${optionAttrs()}>${esc(config.viewAll.replace('__TERM__',term))} <span aria-hidden="true">→</span></button></div></div>`;
          search.setAttribute('results','true');
          search.open();
          refreshFocusTrap();
          search.setLiveRegionText(products.length ? `${products.length} ${config.products}` : config.empty.replace('__TERM__',term));
        } catch (error) {
          if (error.name === 'AbortError' || current !== generation) return;
          results.innerHTML = `<div class="ot-panel"><div class="ot-suggestions"><h2 class="ot-search-heading">${esc(config.suggestions)}</h2><ul class="ot-search-links"><li><a href="${esc(urlFor(term))}">${esc(term)}</a></li></ul></div>${browse}<div class="ot-products"><p class="ot-empty">${esc(config.error)}</p><button type="submit" class="ot-search-all">${esc(config.viewAll.replace('__TERM__',term))} →</button></div></div>`;
          refreshFocusTrap();
          search.setLiveRegionText(config.error);
        } finally {
          if (current === generation) { search.removeAttribute('loading'); input.form.removeAttribute('aria-busy'); if (search.loader) search.loader.style.display = 'none'; }
        }
      };
      input.addEventListener('focus', () => search.closest('.ot-search').classList.add('ot-focused'));
      search.addEventListener('focusout', () => setTimeout(() => { if (!search.contains(document.activeElement)) search.closest('.ot-search').classList.remove('ot-focused'); },0));
      input.addEventListener('input', () => { controller?.abort(); generation++; if (!input.value.trim()) clear(); else { results.innerHTML = original; search.removeAttribute('results'); input.removeAttribute('aria-activedescendant'); refreshFocusTrap(); } });
      input.form.addEventListener('reset', () => { clear(); input.focus(); });
      results.addEventListener('click', event => { const link = event.target.closest('[data-ot-search-term]'); if (!link) return; event.preventDefault(); input.value = link.dataset.otSearchTerm; search.searchTerm = input.value.trim(); search.toggleResetButton(); input.focus(); search.getSearchResults(search.searchTerm); });
      if (input.value.trim()) { search.searchTerm = input.value.trim(); search.getSearchResults(search.searchTerm); }
    });
    document.querySelectorAll('[data-ot-mobile-search]').forEach(link => {
      if (link.dataset.otReady) return;
      const popdown = document.getElementById('search-popdown');
      const form = popdown?.querySelector('predictive-search');
      const underlay = popdown?.closest('[data-search-popdown-wrap]').querySelector('[data-search-underlay]');
      if (!form || !underlay) return;
      link.dataset.otReady = 'true';
      let active = false;
      link.addEventListener('click', event => {
        event.preventDefault();
        active = true;
        popdown.classList.add('is-visible');
        underlay.classList.add('underlay--visible');
        form.a11y.trapFocus(popdown,{elementToFocus:form.input});
        popdown.dispatchEvent(new CustomEvent('theme:scroll:lock',{bubbles:true}));
      });
      new MutationObserver(() => { const open = popdown.classList.contains('is-visible'); link.setAttribute('aria-expanded',String(open)); if (!open && active) { active = false; link.focus(); } }).observe(popdown,{attributes:true,attributeFilter:['class']});
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
